import React, { useContext, useEffect } from "react";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";
import StateConfigurationTable from "./StateConfigurationTable";

import "./stateConfiguration.css";

type StateConfigurationAppContext = {
  setActiveSidebarTab: (tab: string, option?: string) => void;
};

/**
 * Configurations → State Configuration (PENG-78). Per-US-state experience
 * config: whether a state gets the Prediction or Sweepstakes experience,
 * signup age, and per-product toggles (Sportsbook, Discover, Casino, Rip
 * Packs, Culture).
 */
const StateConfigurationPage: React.FC = () => {
  usePageTitle(AppStrings.PAM_STATE_CONFIGURATION_PAGE_TITLE);
  const { setActiveSidebarTab } = useContext(
    AppContext,
  ) as StateConfigurationAppContext;

  useEffect(() => {
    setActiveSidebarTab(
      SIDER_TABS.CONFIGURATIONS,
      AppStrings.PAM_STATE_CONFIGURATION_PAGE_TITLE,
    );
  }, [setActiveSidebarTab]);

  return (
    <>
      <div className="state-config-page">
        <StateConfigurationTable />
      </div>
    </>
  );
};

export default StateConfigurationPage;
